package fr.frux.shared.dto

import kotlinx.serialization.Serializable

/**
 * Transport enum for a tree's harvest status.
 *
 * The serial names (enum entry names) are part of the public API contract:
 * changing or removing one is a breaking change for every client.
 */
@Serializable
enum class TreeStatusDto {
    FLOWERING,
    RIPE_READY,
    PICKED_CLEAN,
    UNAVAILABLE,

    /** Aucun état observé — arbre importé qu'aucun humain n'a encore regardé. */
    UNKNOWN
}
